// extracted by mini-css-extract-plugin
module.exports = {"userMenu":"userMenu_userMenu__1On2V","userIcon":"userMenu_userIcon__2SRU_","menuOptions":"userMenu_menuOptions__qaR18","headerMenu":"userMenu_headerMenu__wp8Bl"};